document.addEventListener('DOMContentLoaded', () => {
  const base = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(base + path, {method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to update your shopping bag. Please try again.');
    return result;
  };
  document.querySelectorAll('[data-engraving]').forEach(panel => {
    const form = panel.closest('form');
    const toggle = panel.querySelector('[data-engraving-toggle]');
    const fields = panel.querySelector('[data-engraving-fields]');
    const rows = [...panel.querySelectorAll('[data-engraving-blade]')];
    const error = panel.querySelector('[data-engraving-error]');
    const quantity = form.querySelector('[name="quantity"]');
    const express = form.querySelector('.dynamic-checkout');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:panel.dataset.currency || 'AUD'}).format(cents / 100);
    const setBlades = Math.max(1, Number(panel.dataset.setBlades) || 1);
    let busy = false;
    let unknownResult = false;
    const chosen = () => rows.filter(row => toggle.checked && (!row.querySelector('[data-engraving-blade-toggle]') || row.querySelector('[data-engraving-blade-toggle]').checked));
    const update = () => {
      fields.hidden = !toggle.checked;
      if (express) express.hidden = toggle.checked;
      rows.forEach(row => {
        const check = row.querySelector('[data-engraving-blade-toggle]');
        const input = row.querySelector('[data-engraving-text]');
        if (check) check.disabled = !toggle.checked;
        input.disabled = !toggle.checked || Boolean(check && !check.checked);
        input.required = !input.disabled;
      });
      const qty = Math.max(1, Number(quantity.value) || 1);
      const count = chosen().length * setBlades;
      panel.querySelector('[data-engraving-total]').textContent = setBlades > 1 ? `${qty} ${qty === 1 ? 'set' : 'sets'} × ${money(setBlades * Number(panel.dataset.unitPrice))} = ${money(qty * setBlades * Number(panel.dataset.unitPrice))}` : `${count * qty} ${count * qty === 1 ? 'knife' : 'knives'} × ${money(Number(panel.dataset.unitPrice))} = ${money(count * qty * Number(panel.dataset.unitPrice))}`;
      toggle.setCustomValidity(toggle.checked && count === 0 ? 'Select at least one knife to engrave.' : '');
      error.hidden = true;
    };
    if (!panel.dataset.serviceId || Number(panel.dataset.unitPrice) !== Number(panel.dataset.expectedPrice)) return;
    toggle.disabled = false;
    toggle.addEventListener('change', update);
    rows.forEach(row => row.querySelector('[data-engraving-blade-toggle]')?.addEventListener('change', update));
    quantity.addEventListener('input', update);
    update();
    form.addEventListener('submit', async event => {
      if (!toggle.checked) return;
      event.preventDefault();
      if (busy || unknownResult) return;
      if (!form.reportValidity()) return;
      for (const row of chosen()) {
        const input = row.querySelector('[data-engraving-text]');
        input.value = input.value.trim();
        input.setCustomValidity(!input.value ? 'Enter your engraving text.' : input.value.length > input.maxLength ? `Use no more than ${input.maxLength} characters, including spaces and punctuation.` : '');
        input.addEventListener('input', () => input.setCustomValidity(''), {once:true});
        if (!input.reportValidity()) return;
      }
      busy = true;
      const buttons = [...document.querySelectorAll('button[type="submit"][form="' + form.id + '"]'), ...form.querySelectorAll('button[type="submit"]')];
      buttons.forEach(button => {button.disabled = true;});
      const group = crypto.randomUUID();
      const id = Number(new FormData(form).get('id'));
      const qty = Number(quantity.value);
      const selected = chosen();
      const properties = {_engraving_group:group, Engraving:setBlades > 1 ? `A$${setBlades * Number(panel.dataset.unitPrice) / 100} per set — same text on all ${setBlades} knives` : `A$${Number(panel.dataset.unitPrice) / 100} per knife`, 'Engraved knives per item': String(selected.length * setBlades)};
      selected.forEach(row => {const input = row.querySelector('[data-engraving-text]'); properties['Engraving — ' + input.dataset.bladeLabel] = input.value;});
      const items = [{id,quantity:qty,properties}, ...selected.map(row => {
        const input = row.querySelector('[data-engraving-text]');
        return {id:Number(panel.dataset.serviceId),quantity:qty * setBlades,parent_id:id,properties:{_engraving_group:group,_engraving_multiplier:String(setBlades),_engraving_fee:'true','For knife':panel.dataset.productTitle,Blade:input.dataset.bladeLabel,'Engraving text':input.value}};
      })];
      try {
        await request('cart/add.js', {items});
        window.location.assign(base + 'cart');
      } catch (failure) {
        error.hidden = false;
        error.textContent = failure.message;
        if (failure instanceof TypeError || failure instanceof SyntaxError) {
          unknownResult = true;
          error.textContent = 'We could not confirm the response. Open your shopping bag to check before adding again.';
          const link = document.createElement('a'); link.href = base + 'cart'; link.textContent = ' View shopping bag'; error.append(link);
        } else buttons.forEach(button => {button.disabled = false;});
        busy = false;
      }
    });
  });
  const cartForm = document.querySelector('[data-engraving-cart]');
  if (!cartForm) return;
  let cartBusy = false;
  cartForm.addEventListener('submit', async event => {
    const rows = [...cartForm.querySelectorAll('[data-cart-line]')];
    if (!rows.some(row => row.dataset.engravingGroup)) return;
    event.preventDefault();
    if (cartBusy || !cartForm.reportValidity()) return;
    cartBusy = true;
    const checkout = event.submitter?.name === 'checkout';
    const error = cartForm.querySelector('[data-cart-error]');
    const buttons = [...cartForm.querySelectorAll('button[type=submit]')];
    buttons.forEach(button => {button.disabled = true;});
    const updates = {};
    rows.filter(row => row.dataset.engravingFee !== 'true').forEach(row => {
      const qty = Number(row.querySelector('[data-cart-quantity]').value);
      updates[row.dataset.key] = qty;
      if (row.dataset.engravingGroup) rows.filter(fee => fee.dataset.engravingFee === 'true' && fee.dataset.engravingGroup === row.dataset.engravingGroup).forEach(fee => {updates[fee.dataset.key] = qty * Math.max(1, Number(fee.dataset.engravingMultiplier) || 1);});
    });
    try {
      const cart = await request('cart/update.js', {updates});
      const mismatch = cart.items.some(item => item.properties?._engraving_group && !item.properties?._engraving_fee && cart.items.filter(fee => fee.properties?._engraving_fee === 'true' && fee.properties?._engraving_group === item.properties._engraving_group).some(fee => fee.quantity !== item.quantity * Math.max(1, Number(fee.properties._engraving_multiplier) || 1)));
      if (mismatch) throw new Error('Please review the knife and engraving quantities before checkout.');
      window.location.assign(base + (checkout ? 'checkout' : 'cart'));
    } catch (failure) {
      error.hidden = false; error.textContent = failure.message;
      buttons.forEach(button => {button.disabled = false;}); cartBusy = false;
    }
  });
});
